import SuspendGame from "./SuspendGame";
import PauseGame from "./PauseGame";
import ResumeGame from "./ResumeGame";
import SoundOff from "./SoundOff";
import SoundOn from "./SoundOn";
import UpdateBalance from "./UpdateBalance";
import ResetGame from "./ResetGame";
import Resize from "./Resize";
import DepositCanceled from "./DepositCanceled";
import DepositCompleted from "./DepositCompleted";
import ExitFullScreen from "./ExitFullScreen";
import OpenPaytable from "./OpenPaytable";
import ClosePaytable from "./ClosePaytable";
import OpenHelp from "./OpenHelp";
import CloseHelp from "./CloseHelp";
import GameLaunchUrl from "./GameLaunchUrl";
import WalletLaunchLinkSwap from "./WalletLaunchLinkSwap";

export default class Events {
    constructor(gb) {
        this.suspendGame = new SuspendGame(gb);
        this.pauseGame = new PauseGame(gb);
        this.resumeGame = new ResumeGame(gb);
        this.soundOff = new SoundOff(gb);
        this.soundOn = new SoundOn(gb);
        this.updateBalance = new UpdateBalance(gb);
        this.resetGame = new ResetGame(gb);
        this.resize = new Resize(gb);
        this.depositCanceled = new DepositCanceled(gb);
        this.depositCompleted = new DepositCompleted(gb);
        this.exitFullScreen = new ExitFullScreen(gb);
        this.openPaytable = new OpenPaytable(gb);
        this.closePaytable = new ClosePaytable(gb);
        this.openHelp = new OpenHelp(gb);
        this.closeHelp = new CloseHelp(gb);
        this.gameLaunchUrl = new GameLaunchUrl(gb);
        this.walletLaunchLinkSwap = new WalletLaunchLinkSwap(gb);
    }

    exposeEvents() {
        return Object.assign({}, {
            ...this.suspendGame.exposeEvent(),
            ...this.pauseGame.exposeEvent(),
            ...this.resumeGame.exposeEvent(),
            ...this.soundOff.exposeEvent(),
            ...this.soundOn.exposeEvent(),
            ...this.updateBalance.exposeEvent(),
            ...this.resetGame.exposeEvent(),
            ...this.resize.exposeEvent(),
            ...this.depositCanceled.exposeEvent(),
            ...this.depositCompleted.exposeEvent(),
            ...this.exitFullScreen.exposeEvent(),
            ...this.openPaytable.exposeEvent(),
            ...this.closePaytable.exposeEvent(),
            ...this.openHelp.exposeEvent(),
            ...this.closeHelp.exposeEvent(),
            ...this.gameLaunchUrl.exposeEvent(),
            ...this.walletLaunchLinkSwap.exposeEvent(),
        })
    }
}
